import React from 'react';
import PropTypes from 'prop-types';
import ObjectIcon from '../shared/ObjectIcon';

import './SalesforceRecordButton.scss';

/**
 * SalesforceRecordButton component
 * @param {string} objectLabel - The label of the object
 * @param {string} objectApiName - The icon of the object
 * @param {function} objectOnClick - The function to call when the object is clicked
 * @return {JSX.Element} - SalesforceRecordButton component
 */
const SalesforceRecordButton = ({ objectLabel, objectApiName, objectOnClick }) => {
  return (
    <button
      className="salesforce-record"
      onClick={objectOnClick}
    >
      <ObjectIcon objectApiName={objectApiName} className="salesforce-record-icon" />
      <span className="salesforce-record-label">{objectLabel}</span>
    </button>
  );
};

export default SalesforceRecordButton;

SalesforceRecordButton.propTypes = {
  objectLabel: PropTypes.string,
  objectApiName: PropTypes.string,
  objectOnClick: PropTypes.func,
};
